// import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredCoiffeurSalonList } from 'types/CoiffeurType'
import {
  ReservationButton,
  CoiffeurSalonName,
  SalonLocation,
  WorkingHours,
  Summary,
  StyledCard,
  CardHeaderOverlay,
  // FavoriteContainer,
} from './styled'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'
// import CoiffeurService from 'service/CoiffeurService'

interface ComponentProps {
  salon: IFilteredCoiffeurSalonList
  openModal: (salon: IFilteredCoiffeurSalonList) => void
}

export default function CoiffeurSalonCard({ salon, openModal }: ComponentProps) {
  const { t } = useTranslation()
  /* ######### Coiffeur Data Destructuring ######### */
  const {
    // Id,
    name,
    startHourStr,
    endHourStr,
    listMainServiceStr,
    // IsFavorite,
    floor: { name: FloorName, locationName: LocationName, districtName: DistrictName, cityName: CityName, countryName: CountryName, blockName: BlockName },
  } = salon || {}

  /* Location String */
  const locationName = `${LocationName}, ${DistrictName}, ${CityName}, ${CountryName}, ${BlockName}, ${FloorName}`
  const coiffeurServices = listMainServiceStr

  const openSearchModal = () => openModal(salon)

  // /* Favorite Coiffeur */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   CoiffeurService.addCoiffeurFavorite(Id).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   CoiffeurService.removeCoiffeurFavorite(Id).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay>
        {/* <FavoriteContainer>
          <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} />
        </FavoriteContainer> */}
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <CoiffeurSalonName>{`${name}`}</CoiffeurSalonName>
          <SalonLocation>{locationName}</SalonLocation>
          {!!listMainServiceStr.length && (
            <Summary>
              {coiffeurServices.map((cs, i) => (
                <p key={i}>{cs}</p>
              ))}
            </Summary>
          )}
        </div>

        <WorkingHours>
          <span className="wh-title">{t('most-used-words.working-hours')} </span>
          <span>
            {startHourStr} - {endHourStr}
          </span>
        </WorkingHours>

        <ReservationButton onClick={openSearchModal}>{t('buttons.book-reservation')}</ReservationButton>
      </div>
    </StyledCard>
  )
}
